export class DashboardCustomizationConst {
    static widgets = {
        tenant: {
            profitShare: 'Widgets_Tenant_ProfitShare',
            memberActivity: 'Widgets_Tenant_MemberActivity',
            regionalStats: 'Widgets_Tenant_RegionalStats',
            salesSummary: 'Widgets_Tenant_SalesSummary',
            topStats: 'Widgets_Tenant_TopStats',
            generalStats: 'Widgets_Tenant_GeneralStats',
            dailySales: 'Widgets_Tenant_DailySales',
            timeSheetTab: 'Widgets_Tenant_MyTimesheettab',
            ProductivityChartInfo: "Widgets_Tenant_ProductivityChartInfo",
            AppCategorySection: "Widgets_Tenant_AppCategorySection",
            ProjectSection: "Widgets_Tenant_ProjectSection",
            ArrivalInfo: "Widgets_Tenant_ArrivalInfo",
            ProjectInfoTab: "Widgets_Tenant_ProjectInfoTab",
            ProductiveAppsSection: "Widgets_Tenant_ProductiveAppsSection",
            UnProductiveAppsSection: "Widgets_Tenant_UnProductiveAppsSection",
            NeutralAppsSection: "Widgets_Tenant_NeutralAppsSection",
            OrgUnit: "Widgets_Tenant_OrgUnits",
            LeaveReports: "Widgets_Tenant_LeaveReports",
            TaskListSection: "Widgets_Tenant_TaskListSection",




            //2nd Tab
            SecondTabProjectsCountInfo: "Widgets_Tenant_SecondTabProjectsCountInfo",
            SecondTabNewJoinerSections: "Widgets_Tenant_SecondTabNewJoinerSections",
            SecondTabProjectSection: "Widgets_Tenant_SecondTabProjectSection",
            SecondTabEmployeeSection: "Widgets_Tenant_SecondTabEmployeeSection",
            SecondTabLeaveReports: "Widgets_Tenant_SecondTabLeaveReports",
            SecondTabTeamTimesheetSection: "Widgets_Tenant_SecondTabTeamTimesheetSection",
            SecondTabTeamDetailsSection: "Widgets_Tenant_SecondTabTeamDetailsSection",
        },
        host: {
            topStats: 'Widgets_Host_TopStats',
            incomeStatistics: 'Widgets_Host_IncomeStatistics',
            editionStatistics: 'Widgets_Host_EditionStatistics',
            subscriptionExpiringTenants: 'Widgets_Host_SubscriptionExpiringTenants',
            recentTenants: 'Widgets_Host_RecentTenants',

        }
    };
    static filters = {
        filterDateRangePicker: 'Filters_DateRangePicker'
    };
    static dashboardNames = {
        defaultTenantDashboard: 'TenantDashboard',
        defaultHostDashboard: 'HostDashboard',
    };
    static Applications = {
        Angular: 'Angular'
    };
}
